export var black = '#000000';
export var white = '#ffffff';
export var purpleDark = '#3417AA';
export var purple = '#4B22F4';
export var purpleMedium = '#6945FF';
export var purpleLight = 'var(--color-primary-light-400)';
export var purpleLighter = '#9C86F9';
export var purpleLighter2 = '#F6F4FE';
export var purpleLighter12 = 'rgba(156, 134, 249, 0.12)';
export var purpleLighter56 = 'rgba(156, 134, 249, 0.56)';
export var blueLighter = '#878FB8';
export var blueLight = '#1D2559';
export var blueMain = '#181B32';
export var blueDark = '#070E27';
export var blueLighter8 = 'rgba(135, 143, 184, 0.08)';
export var blueLighter16 = 'rgba(135, 143, 184, 0.16)';
export var blueLighter24 = 'rgba(135, 143, 184, 0.24)';
export var blueLighter56 = 'rgba(135, 143, 184, 0.56)';
export var blueLighter70 = 'rgba(135, 143, 184, 0.70)';
export var blueMain56 = 'rgba(24, 27, 50, 0.56)';
export var blueMain80 = 'rgba(24, 27, 50, 0.80)';
export var grayLighter = '#F6F7F9';
export var grayLight = '#E8EAF0';
export var grayMain = '#C3CBD6';
export var grayDark = '#8D8D9D';
export var grayLighterDarkMode = '#4F5374';
export var grayMainDarkMode = '#3F425E';
export var grayDark8 = 'rgba(141, 141, 157, 0.08)';
export var grayDark16 = 'rgba(141, 141, 157, 0.16)';
export var grayDark24 = 'rgba(141, 141, 157, 0.24)';
export var grayDark56 = 'rgba(141, 141, 157, 0.56)';
export var grayDark70 = 'rgba(141, 141, 157, 0.70)';
export var redLighter = '#FED5E3';
export var redLight = '#FC81AA';
export var redMain = '#E6215D';
export var redDark = '#930F3B';
export var orangeLighter = '#FFC0B8';
export var orangeLight = '#FF8871';
export var orangeMain = '#E05D1B';
export var orangeDark = '#99441F';
export var yellowLighter = '#FFE0B6';
export var yellowLight = '#FFCD8A';
export var yellowMain = '#FFB200';
export var yellowDark = '#BA7E06';
export var greenLighter = '#DCFFED';
export var greenLight = '#80E0B4';
export var greenMain = '#34D69B';
export var greenDark = '#01605A';
export var convertionLight = '#00EB96';
export var convertionMain = '#00DD8D';
export var primaryLighterHEX = purpleLighter;
export var primaryLightHEX = purpleLight;
export var primaryMainHEX = purple;
export var primaryDarkHEX = purpleDark;
export var primaryLighter = /*#__PURE__*/"var(--color-primary-lighter, ".concat(primaryLighterHEX, ")");
export var primaryLight = /*#__PURE__*/"var(--color-primary-light, ".concat(primaryLightHEX, ")");
export var primaryMain = /*#__PURE__*/"var(--color-primary-main, ".concat(primaryMainHEX, ")");
export var primaryDark = /*#__PURE__*/"var(--color-primary-dark, ".concat(primaryDarkHEX, ")");
export var primaryLighter12 = purpleLighter12;
export var primaryLighter56 = purpleLighter56;
export var secondaryLighterHEX = '#D2FAF6';
export var secondaryLightHEX = '#49F2D2';
export var secondaryMainHEX = '#0BD4C1';
export var secondaryDarkHEX = '#0B756F';
export var secondaryLighter = /*#__PURE__*/"var(--color-secondary-lighter, ".concat(secondaryLighterHEX, ")");
export var secondaryLight = /*#__PURE__*/"var(--color-secondary-light, ".concat(secondaryLightHEX, ")");
export var secondaryMain = /*#__PURE__*/"var(--color-secondary-main, ".concat(secondaryMainHEX, ")");
export var secondaryDark = /*#__PURE__*/"var(--color-secondary-dark, ".concat(secondaryDarkHEX, ")");
export var secondaryLight56 = 'rgba(73, 242, 210, 0.56)';
export var baseLighter = blueLighter;
export var baseLight = blueLight;
export var baseMain = blueMain;
export var baseDark = blueDark;
export var baseLighterDarkMode = '#2C2F48';
export var baseLightDarkMode = '#22253D';
export var baseLighter8 = blueLighter8;
export var baseLighter16 = blueLighter16;
export var baseLighter24 = blueLighter24;
export var baseLighter56 = blueLighter56;
export var baseLighter70 = blueLighter70;
export var baseMain56 = blueMain56;
export var baseMain80 = blueMain80;

/**
 * @deprecated use purple
 */
export var primaryColor = purple;
/**
 * @deprecated use baseMain
 */
export var primaryText = baseMain;
var colors = {
  transparent: 'transparent',
  black: black,
  white: white,
  primary: {
    lighter: primaryLighter,
    light: primaryLight,
    main: primaryMain,
    dark: primaryDark,
    'lighter-12': primaryLighter12,
    'lighter-56': primaryLighter56
  },
  secondary: {
    lighter: secondaryLighter,
    light: secondaryLight,
    main: secondaryMain,
    dark: secondaryDark,
    'light-56': secondaryLight56
  },
  base: {
    lighter: baseLighter,
    light: baseLight,
    main: baseMain,
    dark: baseDark,
    'lighter-dark-mode': baseLighterDarkMode,
    'light-dark-mode': baseLightDarkMode,
    'lighter-8': baseLighter8,
    'lighter-16': baseLighter16,
    'lighter-24': baseLighter24,
    'lighter-56': baseLighter56,
    'lighter-70': baseLighter70,
    'main-56': baseMain56,
    'main-80': baseMain80
  },
  purple: {
    dark: purpleDark,
    main: purple,
    medium: purpleMedium,
    light: purpleLight,
    lighter: purpleLighter,
    'lighter-2': purpleLighter2
  },
  gray: {
    lighter: grayLighter,
    light: grayLight,
    main: grayMain,
    dark: grayDark,
    'lighter-dark-mode': grayLighterDarkMode,
    'main-dark-mode': grayMainDarkMode,
    'dark-8': grayDark8,
    'dark-16': grayDark16,
    'dark-24': grayDark24,
    'dark-56': grayDark56,
    'dark-70': grayDark70
  },
  red: {
    lighter: redLighter,
    light: redLight,
    main: redMain,
    dark: redDark
  },
  orange: {
    lighter: orangeLighter,
    light: orangeLight,
    main: orangeMain,
    dark: orangeDark
  },
  yellow: {
    lighter: yellowLighter,
    light: yellowLight,
    main: yellowMain,
    dark: yellowDark
  },
  green: {
    lighter: greenLighter,
    light: greenLight,
    main: greenMain,
    dark: greenDark
  },
  convertion: {
    light: convertionLight,
    main: convertionMain
  },
  inherit: 'inherit'
};
export default colors;